"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var i18next_1 = __importDefault(require("i18next"));
var i18next_xhr_backend_1 = __importDefault(require("i18next-xhr-backend"));
var react_i18next_1 = require("react-i18next");
var util_1 = require("@aperza/util");
var preload = ['ja'];
var locale = 'ja';
var appConfig = util_1.AppService.appConfig();
if (appConfig.langCode) {
    locale = appConfig.langCode;
    if (locale != 'ja') {
        preload.push(locale);
    }
}
var serverHost = util_1.AppService.serverHost();
exports.initializeI18N = function () {
    i18next_1.default
        .use(i18next_xhr_backend_1.default)
        .use(react_i18next_1.initReactI18next) // bind react-i18next to the instance
        .init({
        fallbackLng: 'ja',
        fallbackNS: 'aw',
        defaultNS: 'aw',
        preload: ['ja'],
        ns: ['aw', 'catalog', 'application'],
        lng: locale,
        debug: false,
        backend: {
            // for all available options read the backend's repository readme file
            loadPath: serverHost + "/i18n/{{lng}}/{{ns}}.json",
        },
    });
};
//# sourceMappingURL=i18n.js.map